/* unplugin-vue-components disabled */import { render } from "./Induction.vue?vue&type=template&id=2230622d"
import script from "./Induction.vue?vue&type=script&lang=js"
export * from "./Induction.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__